import KidoAPIInstance from "../../services/KidoConfigApi";

export const getListNotificationApi = async status => {
	let path = `api/notification/list`;
	if (status !== "ALL") {
		path = path + `?status=${status}`;
	}
	return await KidoAPIInstance.get(path);
};

export const getNotificationDetailApi = async id => {
	const path = `api/notification/detail?notificationId=${id}`;
	return await KidoAPIInstance.get(path);
};

export const getTotalNotificationApi = async () => {
	const path = "api/notification/total";
	return await KidoAPIInstance.get(path);
};

export const postWatchedNotificationApi = async data => {
	const path = "api/notification/watched";
	return await KidoAPIInstance.post(path, data);
};
